import { Arbeitsschuh } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesHolzknechtMuseum({ currentMuseumId }) {
  const { arbeitsschuh } = Arbeitsschuh();

  const artefactArray = [arbeitsschuh];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
